// extracted by mini-css-extract-plugin
module.exports = {"form_error":"styles_form_error__sVX8K"};